import auth from './auth';
import { search } from './search';
import { navigation } from './navigation';
import { mediaQuery } from './mediaQuery';
import { models } from './models';
import { preferences } from './preferences';

export default { auth, search, navigation, mediaQuery, models, preferences };
